<template>
  <div class="d-flex flex-column vh-100">
    <template v-if="!loggedIn">
      <router-view/>
    </template>

    <template v-if="loggedIn">
      <navigation-top/>
      
      <div id="main" class="d-flex flex-grow-1">
        <navigation-side/>

        <div id="content" class="flex">
          <router-view/>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import NavigationTop from './components/NavigationTop'
import NavigationSide from './components/NavigationSide'

import { AUTH_LOGOUT } from '@/store/actions/auth'

import { mapGetters } from 'vuex';

export default {
  name: 'app',
  components: {
    NavigationTop,
    NavigationSide,
  },
  computed: {
    loggedIn : function() {
      return this.$store.getters.isAuthenticated;
    },
    ...mapGetters([
      'isSuperUser'
    ]),
  },
  methods: {
    logout: function() {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/login'))
    },
  },
  mounted() {
  },
}
</script>

<style lang="scss">

$section-border-color: #efefef;
$body-bg:       	#f7f8fa;

body {

    color: #545454;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.v-select .dropdown-toggle::after,
.guidelines-editor .v-select .dropdown-toggle::after{
  content: initial;
}

.v-select .dropdown-menu,
.guidelines-editor .v-select .dropdown-menu{
  overflow-y: auto !important;
}

#content {
  overflow-y: auto;
}

.vh-100{
  height: 100vh;
}

.page-container-wrapper {
  padding: 0 20px 20px 20px;
}

.page-container-header{
  height: 70px;
  justify-content: space-between;
}

.page-container-header h2 {
  color: #137eff;
}

.page-container-toolbar {
  height: 60px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 15px;
  border-bottom: 1px solid rgba(111, 111, 111, 0.06);
}

.page-container-toolbar.bottom {
 border-top: 1px solid rgba(111, 111, 111, 0.06); 
}

.card {
  box-shadow: none;
}

.card-body h4 {
  margin-bottom: 2rem;
  margin-top: 2rem;
  font-size: 0.8rem;
  border-bottom: 1px solid #dddddd;
  padding-bottom: 0.7rem;
  //text-transform: uppercase;
  font-weight: bold;
  color: #6f6f6f;
}

.col-form-label {
  width: 100%;
  text-align: right;
    color: #888888;
}

.btn:hover, .btn:active {
  box-shadow: none;
}

.icon-btn .nav-icon {
  color: #ffffff;
  background-color: #007bff;
  width: 1.8rem;
  height: 1.8rem;
  margin-top: 3px;
}

.sidenav {
  border-right: 1px solid $section-border-color;
}

.sidenav-content {
  background-color: #242939;
}

.router-link-active {
  color: #ffffff !important;
}

.nav-border li.active > a {
  color: #ffffff;
}

.nav-border .nav > li.active:after {

  border-color: #ffffff;
}
  .sidenav-bottom {
    background-color: #1F2433;
  }

  .full-size-container {
    max-width: none;
  }

  .badge {
    padding: 4px 5px;
  }

.phase0 {background-color: #8875AC} /* PHASE_DRAFT */
.phase10 {background-color: #A3C1E3} /* PHASE_SUBMITTED */
.phase30 {background-color: #92683C} /* PHASE_ADDITIONAL_WORK_NEED */
.phase40 {background-color: #EB4897} /* PHASE_PRE_APPROVED */
.phase42 {background-color: #5BB5D6} /* PHASE_UPLOADED_FOR_GPC_REVIEW */
.phase44 {background-color: #5BB5D6} /* PHASE_UPLOAD_GPC_REVIEWED */
.phase46 {background-color: #DE8344} /* PHASE_UPLOAD_GPC_REVIEW_END */
.phase50 {background-color: #EAB38B} /* PHASE_UPLOADED_FOR_REVIEW */
.phase52 {background-color: #16A085} /* PHASE_PARALLEL_REVIEW — PLACEHOLDER colour, awaiting final */
.phase54 {background-color: #D35400} /* PHASE_PARALLEL_REVIEWED — PLACEHOLDER colour, awaiting final */
.phase56 {background-color: #8E44AD} /* PHASE_PARALLEL_REVIEW_END — PLACEHOLDER colour, awaiting final */
.phase60 {background-color: #F4CB8B} /* PHASE_UPLOAD_REVIEWED */
.phase70 {background-color: #5E813F} /* PHASE_UPLOAD_REVIEW_END */
.phase80 {background-color: #4FAD5B} /* PHASE_REVIEW_BY_NATIONAL_DELEGATES */
.phase90 {background-color: #B1CF95} /* PHASE_REVIEWED_BY_NATIONAL_DELEGATES */
.phase100 {background-color: #353F4E} /* PHASE_REVIEW_BY_NATIONAL_DELEGATES_END */
.phase102 {background-color: #4288A1} /* PHASE_GPC_FINAL_APPROVAL */
.phase104 {background-color: #25505E} /* PHASE_GPC_FINAL_HOLD */
.phase110 {background-color: #B929AE} /* PHASE_BOARD_APPROVAL */
.phase120 {background-color: #F7CE46} /* PHASE_BOARD_APPROVAL_APPROVED */
.phase130 {background-color: #68349A} /* PHASE_BOARD_APPROVAL_ON_HOLD */
.phase140 {background-color: #A5A5A5} /* PHASE_FINAL_PUBLISHED */

  .badge-success {
    background-color: #1dc9b7;
  }


.filter-checkbox {
  height: 44px;
  border-bottom: 1px solid $body-bg;
  display: flex;
  align-items: center;

  .custom-control-label::before, .custom-control-label::after {
    top: 15px;
    left: 10px;
    border-radius: 0;
  }

  .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #1dc9b7;
    border: none;
  }

  .custom-control-input ~ .custom-control-label::before {
    background-color: transparent;
    border: 1px solid #888888;
  }

  label {
    padding-left: 8px;
  }
}
  .shadow-on-box {
    box-shadow: 0px 0px 13px 0px rgba(82, 63, 105, 0.05);
  }

  .stepper-container {
    background-color: #ffffff;
    padding: 25px 15px;
    border-top: 1px solid #efefef;
    display: flex;
    justify-content: space-between;
  }

  .guidelines-editor {
    background-color: #ffffff;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }

  ul.dropdown-menu {

  }




.v-select .selected-tag {
  color: #147688;
  background-color: #d7f3f9;
  border-color: #91ddec;
}

.v-select.dropdown.open .dropdown-toggle,
.v-select.dropdown.open .dropdown-menu {
  border-color: #4CC3D9;
}

.v-select .active a {
  background: rgba(50,50,50,.1);
  color: #333;
}

.v-select.dropdown .highlight a,
.v-select.dropdown li:hover a {
  background: #00C9B6;
  color: #fff;
}

  .action-button-container {
    display: flex;
  }

  .p20 {
    padding: 20px;
  }

  .preLine {
    white-space: pre-line;
  }
</style>
